import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import Component from './Component';
import {getTourById, changeEditTourData, deletePhotoTour, addPhotoTour, editTour, uploadVideo, deleteVideoTour, cleanState} from '../../Action';

const stateToProps = (state) => {
  return {
    cities: state.main.cities,
    categories: state.main.tourCategories,
    tourData: state.vendor.tourForEdit,
    getTourByIdRejected: state.vendor.promise.getTourById.isRejected,
    getTourByIdSuccess: state.vendor.promise.getTourById.isSuccess,
    isPendingUploadVideo: state.vendor.promise.uploadVideo.isPending,
  }
};

const mapToProps = (dispatch) => {
  return {
    getTourById: (data, checkVideo) => {
      dispatch(getTourById(data, checkVideo))
    },
    changeEditTourData: (data) => {
      dispatch(changeEditTourData(data))
    },
    deletePhotoTour: (data) => {
      dispatch(deletePhotoTour(data))
    },
    addPhotoTour: (data) => {
      dispatch(addPhotoTour(data))
    },
    editTour: (data, history) => {
      dispatch(editTour(data, history))
    },
    uploadVideo: (data) => {
      dispatch(uploadVideo(data))
    },
    deleteVideoTour: (data, cb) => {
      dispatch(deleteVideoTour(data, cb))
    },
    cleanState: () => {
      dispatch(cleanState())
    }

  }
};

export default withRouter(connect(stateToProps, mapToProps)(Component));


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/EditTour/index.js